/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantProductMappingInput
 */
export interface GoogleMerchantProductMappingInput {
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingInput
     */
    erpIntegrationId: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleMerchantProductMappingInput
     */
    erpProductRemoteId: string;
    /**
     * Human-auditable reason for confirming or changing the mapping.
     * @type {string}
     * @memberof GoogleMerchantProductMappingInput
     */
    reason: string;
}

/**
 * Check if a given object implements the GoogleMerchantProductMappingInput interface.
 */
export function instanceOfGoogleMerchantProductMappingInput(value: object): value is GoogleMerchantProductMappingInput {
    if (!('erpIntegrationId' in value) || value['erpIntegrationId'] === undefined) return false;
    if (!('erpProductRemoteId' in value) || value['erpProductRemoteId'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function GoogleMerchantProductMappingInputFromJSON(json: any): GoogleMerchantProductMappingInput {
    return GoogleMerchantProductMappingInputFromJSONTyped(json, false);
}

export function GoogleMerchantProductMappingInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantProductMappingInput {
    if (json == null) {
        return json;
    }
    return {
        
        'erpIntegrationId': json['erpIntegrationId'],
        'erpProductRemoteId': json['erpProductRemoteId'],
        'reason': json['reason'],
    };
}

export function GoogleMerchantProductMappingInputToJSON(json: any): GoogleMerchantProductMappingInput {
    return GoogleMerchantProductMappingInputToJSONTyped(json, false);
}

export function GoogleMerchantProductMappingInputToJSONTyped(value?: GoogleMerchantProductMappingInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'erpIntegrationId': value['erpIntegrationId'],
        'erpProductRemoteId': value['erpProductRemoteId'],
        'reason': value['reason'],
    };
}

